//import { Component, OnInit } from '@angular/core';
import { REPORTS } from '../models/reports';

import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, animate, transition, style } from '@angular/animations';

import Utils from '../shared/utility';
import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { AdvisorBarService } from '../shared/advisor-bar/advisor-bar.service';
import { LoadingService } from '../shared/loading/loading.service';

import { PagerService } from '../services/pager.service';

@Component({
  selector: 'app-view-reports',
  templateUrl: './view-reports.component.html',
  styleUrls: ['./view-reports.component.css']
})
export class ViewReportsComponent implements OnInit {
  //reports: any = REPORTS;

  private reports: any[];
  private error:string;

  private allItems: any[];
  private filteredReports: any[];
  pager: any = {};
  pagedItems: any[];

  private role: any;

  constructor(private pagerService: PagerService, private globalService: GlobalService, private snackBarService: SnackBarService, private loadingService: LoadingService) { 
    this.getReports();
  }

  ngOnInit() {
    this.role = Number(localStorage.getItem('roleId'));

  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.filteredReports.length, page);

    // get current page of items
    this.pagedItems = this.filteredReports.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  assignCopy(){
    this.filteredReports = Object.assign([], this.allItems);
  }

  filterItem(value){
    this.filteredReports = Object.assign([], this.allItems).filter(
      report => {
        return (report.c.FirstName + " " + report.c.LastName + " " + report.c.spouseName).toLowerCase().includes(value.toLowerCase()) || (report.o.Name).toLowerCase().includes(value.toLowerCase()) || (report.a.FirstName + " " + report.a.LastName).toLowerCase().includes(value.toLowerCase())
      }
    );
    
    if (!this.filteredReports.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
}

  getReports() {
    this.loadingService.isLoading(true);
    this.globalService.getReportsData()
        .subscribe(
            reports => { 
              var allReports = [];
              let mariedStatus = 'Married';
              let singleStatus = 'Single';

              for (var type in reports) {
                reports[type].forEach((report) => {                 

                  if (report.ss) {
                    /* report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                    report.c.irr = report.ic.IRR; */        
                    report.c.annualIncome = '120,000';
                    report.c.irr = 100;                          
                    report.c.clientName = report.ss.FrmName0;
                    report.c.maritalStatus = report.ss.MaritalState == 'Married' ? mariedStatus : singleStatus;                 
                  } 
                  else if (report.mmt) {
                    /* report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                    report.c.irr = report.ic.IRR; */
                    report.c.annualIncome = '120,000';
                    report.c.irr = 100;  
                    report.c.clientName = report.mmt.FrmName0;
                    report.c.maritalStatus = report.mmt.IncludePartner == 'True' ? mariedStatus : singleStatus; 
                  } 
                  else if (report.hc) {
                    /* report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                    report.c.irr = report.ic.IRR; */
                    report.c.annualIncome = '120,000';
                    report.c.irr = 100;  
                    report.c.clientName = report.hc.FrmName0;
                    report.c.maritalStatus = report.hc.FrmIncome.toLowerCase().includes('mfj') ? report.hc.FrmName1.includes('undefined') ? report.hc.FrmName1.replace('undefined', '') : mariedStatus : singleStatus;                                        
                  } 
                  else if (report.ltc) {
                   /*  report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                    report.c.irr = report.ic.IRR; */
                    report.c.annualIncome = '120,000';
                    report.c.irr = 100;  
                    report.c.clientName = report.ltc.FrmName0;
                    report.c.maritalStatus = report.ltc.FrmHasPartner == 'True' ? mariedStatus : singleStatus;
                  }

                  allReports.push(report);
                });
              }
     

              this.reports = allReports;            
          
              this.allItems = this.reports;
          

              this.filteredReports = this.reports.sort(function(a, b) {
                return parseInt(b.r.ID) - parseInt(a.r.ID);
              });       
              
              this.setPage(1);
              this.loadingService.isLoading(false);
             
            },
            error => {
              this.error = <any>error
              this.loadingService.isLoading(false);
            });
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : '--';
  }

  formatReportTypeID(ReportTypeID: number) {
    return Utils.formatReportTypeID(ReportTypeID);
  }

}
